import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    tabBar: {
      backgroundColor: '#eceff1'
    },
    mt1: {
      marginTop: theme.spacing(1)
    },
    mt2: {
      marginTop: theme.spacing(2)
    },
    pl1: {
      paddingLeft: theme.spacing(1)
    }
  });
});
